import { NgModule } from '@angular/core';
import { NgbProgressbarModule }       from '@ng-bootstrap/ng-bootstrap';

import { SharedModule }                from '../shared/shared.module';
import { AttachmentComponent }         from './attachment.component';
import { AttachmentsBoxComponent }     from './attachments.box.component';
import { EmailAttachmentsComponent }   from './attachments.email.component';
import { VideoViewerComponent }        from './attachment.video-viewer.component';

@NgModule({
  declarations: [
    AttachmentComponent,
    AttachmentsBoxComponent,
    EmailAttachmentsComponent,
    VideoViewerComponent
  ],
  entryComponents: [
    AttachmentComponent,
    AttachmentsBoxComponent,
    EmailAttachmentsComponent,
    VideoViewerComponent
  ],
  exports: [
    AttachmentsBoxComponent,
    EmailAttachmentsComponent
  ],
  imports: [
    NgbProgressbarModule,
    SharedModule
  ]
})
export class AttachmentsModule {}
